'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/octa-whatsapp/~/axios/lib/cancel/isCancel.js
// module id = ryKy
// module chunks = 1